import React from "react";

const defaultEIAData = [
  {
    projectName: "",
    notificationNo: "",
    date: "",
    conductedExternally: "",
    resultsPublic: "",
    webLink: "",
  },
];

const EIAComplianceTable = ({ eiaData, setEiaData }) => {
  const handleChange = (index, field, value) => {
    const updated = [...eiaData];
    updated[index][field] = value;
    setEiaData(updated);
  };

  const addRow = () => {
    setEiaData([
      ...eiaData,
      {
        projectName: "",
        notificationNo: "",
        date: "",
        conductedExternally: "",
        resultsPublic: "",
        webLink: "",
      },
    ]);
  };

  const removeRow = () => {
    if (eiaData.length > 1) {
      setEiaData(eiaData.slice(0, -1));
    }
  };

  return (
    <>
      <div
        style={{
          overflowX: "auto",
          marginTop: 20,
          border: "1px solid #000",
          overflow: "hidden",
          borderRadius: "8px",
        }}
      >
        <table
          style={{
            width: "100%",
            borderCollapse: "collapse",
          }}
        >
          <thead>
            <tr style={{ backgroundColor: "#d8cbd4" }}>
              <th style={headerCell}>Name and brief details of project</th>
              <th style={headerCell}>EIA Notification No.</th>
              <th style={headerCell}>Date</th>
              <th style={headerCell}>
                Whether conducted by independent external agency (Yes / No)
              </th>
              <th style={headerCell}>
                Results communicated in public domain (Yes / No)
              </th>
              <th style={headerCell}>Relevant Web link</th>
            </tr>
          </thead>
          <tbody>
            {eiaData.map((row, index) => (
              <tr key={index}>
                <td style={cell}>
                  <input
                    type="text"
                    placeholder="Name & Detail"
                    value={row.projectName}
                    onChange={(e) =>
                      handleChange(index, "projectName", e.target.value)
                    }
                    style={inputStyle}
                  />
                </td>
                <td style={cell}>
                  <input
                    type="text"
                    placeholder="No."
                    value={row.notificationNo}
                    onChange={(e) =>
                      handleChange(index, "notificationNo", e.target.value)
                    }
                    style={inputStyle}
                  />
                </td>
                <td style={cell}>
                  <input
                    type="text"
                    placeholder="Date"
                    value={row.date}
                    onChange={(e) =>
                      handleChange(index, "date", e.target.value)
                    }
                    style={inputStyle}
                  />
                </td>
                <td style={cell}>
                  <input
                    type="text"
                    placeholder="Yes / No"
                    value={row.conductedExternally}
                    onChange={(e) =>
                      handleChange(index, "conductedExternally", e.target.value)
                    }
                    style={inputStyle}
                  />
                </td>
                <td style={cell}>
                  <input
                    type="text"
                    placeholder="Yes / No"
                    value={row.resultsPublic}
                    onChange={(e) =>
                      handleChange(index, "resultsPublic", e.target.value)
                    }
                    style={inputStyle}
                  />
                </td>
                <td style={cell}>
                  <input
                    type="text"
                    placeholder="Link"
                    value={row.webLink}
                    onChange={(e) =>
                      handleChange(index, "webLink", e.target.value)
                    }
                    style={inputStyle}
                  />
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      <div
        style={{
          display: "flex",
          justifyContent: "center",
          marginTop: "10px",
          gap: "10px",
        }}
      >
        <button onClick={removeRow} style={removeButtonStyle}>
          - Remove
        </button>
        <button onClick={addRow} style={addButtonStyle}>
          + Add More
        </button>
      </div>
    </>
  );
};

// Styles
const headerCell = {
  border: "1px solid #000",
  padding: "10px",
  textAlign: "center",
  fontWeight: "bold",
  backgroundColor: "#d3c9ce",
  fontSize: "14px",
};

const cell = {
  border: "1px solid #ccc",
  padding: "10px",
  textAlign: "left",
};

const inputStyle = {
  width: "100%",
  padding: "10px",
  borderRadius: "4px",
  border: "1px solid gray",
  fontSize: "14px",
};

const addButtonStyle = {
  backgroundColor: "white",
  border: "1px solid lightgrey",
  color: "grey",
  borderRadius: "4px",
  padding: "8px 12px",
  cursor: "pointer",
};

const removeButtonStyle = {
  backgroundColor: "white",
  border: "1px solid lightgrey",
  color: "grey",
  borderRadius: "4px",
  padding: "8px 12px",
  cursor: "pointer",
};

export default EIAComplianceTable;
